module.exports = __webpack_public_path__ + "img/25-f150.b70f8ee7.png";